function create_html(product,variant) {
    var images = product.images;
    var content = product.body_html.replace(/<\/?[^>]+(>|$)/g, "").substr(0,50);
    var url = product.handle;
    var name = variant.title != 'Default Title' ? product.title+' '+variant.title : product.title;
    var price = parseFloat(variant.compare_at_price) > parseFloat(variant.price) ? '<span class="price-sale"><span class="money" data-currency-'+shop_currency+'="'+money_format+(variant.price)+'" data-currency="'+shop_currency+'">'+money_format+(variant.price)+'</span></span><span class="price-compare"><span class="money" data-currency-'+shop_currency+'="'+money_format+(variant.compare_at_price)+'" data-currency="'+shop_currency+'">'+money_format+(variant.compare_at_price)+'</span></span>':'<span class="price-sale"><span class="money" data-currency-'+shop_currency+'="'+money_format+(variant.price)+'" data-currency="'+shop_currency+'">'+money_format+(variant.price)+'</span></span>';
    var sale_0ff = parseFloat(variant.compare_at_price) > parseFloat(variant.price) ? 100 - Math.round((parseFloat(variant.price)*100 / parseFloat(variant.compare_at_price)))+'% Off':'';
    var html = '<div class="collection-product"> ' +
        '<div class="product-infor"> ' +
        '<div class="product-infor-img"> ' +
        '<a href="/products/'+url+'">' +
        '<img src="'+images[0].src+'"> ' +
        '</a>' +
    '<div class="product-hover"> ' +
    '<div class="data-grid-view"> ' +
    '<div class="action-icon"> ' +
    '<form action="cart/add" method="post">'+
    '<input type="hidden" name="quantity" value="1">' +
    '<input type="hidden" name="id" value="'+variant.id+'">' +
    '<div class="button-wrap" data-variant="'+variant.id+'">' + 
    '<button  type="submit" class="product-add-to-cart" data-toggle="tooltip" title="Add to cart" data-placement="top">' +
    '<i class="fas fa-shopping-cart"></i>' +
    '</button>' +
    '</div>' + 
    '</form>' +
    '<a  data-variant="'+variant.id+'" data-toggle="tooltip" data-placement="top" title="Wishlist" class="add-wishlist"><i class="fas fa-heart"></i></a>' +
    '<a class="quick-view" data-handle="'+url+'" data-toggle="tooltip" title="Quickview" data-placement="top"><i class="fas fa-expand"></i></a>' +
    '</div> ' +
    '</div> ' +
    '</div> ' +
    '</div>' +
    '<div class="product-infor-text"> ' +
    '<p><a href="/products/'+url+'">'+name+'</a></p>' +
    '<p>'+price+'</p> ' +
    '</div> </div> ';
    return html;
}
if ($('.wishlist-container').length > 0) {
    if(customer_id != '') {
        $.ajax({
            url: 'https://farost.net/appshopify/wishlist/wishlist.php',
            type: 'GET',
            data: {
                customer_id: customer_id,
                shop: domain,
                type: 'get'
            },
            dataType: 'json'
        }).always(function (response) {
            var products = response.data;
            var wish = wishlists.split(',');
            var results = [];
            if(products.length > 0) {
                $('.isotope-wish').empty();
                $('.clear-wishlist').show();
                $('a.continue').addClass('left');
                $.each(products, function (i, e) {
                    if (results == null) {
                        results.push(products[0]);
                    } else {
                        var isset = true;
                        $.each(results, function (j, p) {
                            if (e.id.toString() == p.id.toString()) {
                                isset = false;
                                return false;
                            }
                        });
                        if (isset) {
                            results.push(e);
                        }
                    }
                });
                products = results;
                for (var i = 0; i <= products.length; i++) {
                    var product = products[i];
                    if (typeof product !== "undefined") {
                        if (product.variants.length > 1) {
                            $.each(product.variants, function (i, e) {
                                $.each(wish, function (j, w) {
                                    if (e.id.toString() == w) {
                                        var html = create_html(product, e);
                                        $('.isotope-wish').append(html);
                                    }
                                })
                            });
                        } else {
                            var html = create_html(product, product.variants[0]);
                            $('.isotope-wish').append(html);
                        }
                    }
                }
                // setInterval(function(){
                //     $('.isotope-wish').isotope({filter:'*'});
                // },1000);
            }
        });
    }
}

$(document).on('click', '.add-wishlist', function(e) {
    e.preventDefault();
    var $this = $(this);
    $this.children('i').addClass('loading');
    var variant_id = $this.attr('data-variant');

    if (customer_id == "") {
        return;
    }
    var data = {
        customer_id: customer_id,
        variant_id: variant_id,
        type: 'update',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            var variant_id_numb = Number(variant_id);
            if (response.type == "add") {
                $this.find('.fa-heart').removeClass('far').addClass('fas');
                $this.children('i').removeClass('loading');
                var index_id = wishlists_arr.indexOf(variant_id_numb);
                if (index_id == -1) {
                    wishlists_arr.push(variant_id_numb);
                }
            }
            if (response.type == "remove") {
                $this.find('.fa-heart').removeClass('fas').addClass('far');
                $this.children('i').removeClass('loading');
                var index_id = wishlists_arr.indexOf(variant_id_numb);
                if (index_id >= 0) {
                    wishlists_arr.splice(index_id, 1);
                }
            }
        }else{
            console.log('ajax error!');
        }
    });
});
$(document).on('click', 'a.in-wished', function(e) {
    e.preventDefault();
    var $this = $(this);
    var variant_id = $this.attr('data-variant');
    if (customer_id == "") {
        return;
    }
    var data = {
        customer_id: customer_id,
        variant_id: variant_id,
        type: 'update',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            if (response.type == "remove") {
                $this.parents('.col-sm-3').fadeOut('slow').remove();
                window.location = window.location;
            }
        }
    });
});
$(document).on('click', 'a.clear-wishlist', function(e) {
    e.preventDefault();
    var data = {
        customer_id: customer_id,
        type: 'delete-all',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            window.location = window.location;
        }
    });
});